var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionList2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 3.34884C9.4075 3.34884 9.00729 3.18488 8.67438 2.85698C8.34146 2.52907 8.175 2.13488 8.175 1.67442C8.175 1.21395 8.34146 0.819767 8.67438 0.49186C9.00729 0.163953 9.4075 0 9.875 0C10.3425 0 10.7427 0.163953 11.0756 0.49186C11.4085 0.819767 11.575 1.21395 11.575 1.67442C11.575 2.13488 11.4085 2.52907 11.0756 2.85698C10.7427 3.18488 10.3425 3.34884 9.875 3.34884ZM4.35 18L6.6875 6.19535L5.2 6.82326V9.62791H3.5V5.69302L7.9625 3.89302C8.345 3.73953 8.73458 3.72209 9.13125 3.8407C9.52792 3.9593 9.8325 4.2 10.045 4.56279L10.8525 5.90233C11.235 6.51628 11.7485 7.01163 12.3931 7.38837C13.0377 7.76512 13.7567 7.95349 14.55 7.95349V9.62791C13.615 9.62791 12.7473 9.43256 11.9469 9.04186C11.1465 8.65116 10.47 8.12093 9.9175 7.45116L9.4075 9.96279L11.15 11.6791V18H9.45V12.9767L7.6225 11.3023L6.135 18H4.35ZM16.0375 18V6.27907H12.85V0.418605H20.5V6.27907H17.3125V18H16.0375ZM17.1213 5.42093L19.225 3.34884L17.1213 1.27674L16.2075 2.17674L16.76 2.72093H14.125V3.97674H16.76L16.2075 4.52093L17.1213 5.42093Z",
    fill: "white",
    fillOpacity: 0.75
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionList2);
export default __webpack_public_path__ + "static/media/action_list_2.4a01cd6f.svg";
export { ForwardRef as ReactComponent };